import { Contact } from '@/layout/Appointment';
import { ContactUs } from '@/layout/ContactUs';
import { Footer } from '@/layout/Footer';
import { Nav } from '@/layout/Nav';
import { SkipNavContent, SkipNavLink } from '@/layout/SkipNav';
import { StickyCallBar } from '@/layout/StickyCallBar';
import { GlobalStyles, theme } from '@/layout/styles/GlobalStyles';
import { ThemeProvider } from '@emotion/react';
import useLocationData from '@s/hooks/useLocationData';
import { Script } from 'gatsby';
import { ReactNode } from 'react';

export const DefaultLayout = ({ children }: { children: ReactNode }) => {
    const { pageTitle } = useLocationData();
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <SkipNavLink />
            <Nav />
            <SkipNavContent />
            <main>{children}</main>
            {pageTitle === 'contact-us' ? '' : <ContactUs />}
            <Contact />
            <Footer />
            <StickyCallBar />
            <Script
                src="https://storage.googleapis.com/chckup-server.appspot.com/widget/index.js"
                strategy="idle"
            />
        </ThemeProvider>
    );
};
